// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"abb9403d","181":"e0beae69","453":"fe6f5a6a","619":"9a84876d","667":"cef33dc4","831":"7172eaa0","920":"cf46e700"}[chunkId] + ".chunk.js";
};